import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../components/action-buttons/action-buttons.types';
import { ActionButtonBase } from '../../directives/action-buttons-base.directive';

/** User-settings key the column configuration is saved under. */
export const STOCKS_COLUMN_LIST = 'column_list-stocks';

/** Form key the plant's allowed fields are read under. */
export const STOCKS_FIELDS_KEY = 'STOCKS_MODULE_FORMKEY';

/** Namespace the column captions are translated from, by field name. */
export const STOCKS_COLUMN_LABEL_PREFIX = 'defaultFields.stocks-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const STOCKS_COLUMNS_DIALOG_ID = 'stocks-select-columns-dialog';

export const STOCKS_TEST_IDS = {
  columnSelect: 'stocks-column-select',
} as const;

export enum StocksActionName {
  ADD = 'ADD',
  CHATBOT = 'CHATBOT',
}

export type StocksActionButton = ActionButtonBase<StocksActionName> & {
  tooltipKey: string;
  visibilityRule?: 'stocksCreate';
};

export const stocksActionButtons: StocksActionButton[] = [
  {
    color: ButtonColor.Red,
    icon: 'add',
    name: StocksActionName.ADD,
    tooltipKey: 'stocksList.add',
    visibilityRule: 'stocksCreate',
  },
  chatbotActionButton(StocksActionName.CHATBOT),
];
